export default "__VITE_ASSET__kf1lSDP4__"